import {Routes, RouterModule} from '@angular/router';

import {PageNotFoundComponent} from '@angular/synthrone-design/components';
import {DashboardViewComponent} from '@synthroneApp/components/views/dashboard/dashboard.component';
import {UsersViewComponent} from '@synthroneApp/components/views/users/users.component';
import {NotificationsViewComponent} from '@synthroneApp/components/views/notifications/notifications.component';
import {MaintenanceViewComponent} from '@synthroneApp/components/views/maintenance/maintenance.component';
import {LoginViewComponent} from '@synthroneApp/components/views/login/login.component';
import {AuthenticateGuard} from '@synthroneApp/guards/authenticate/authenticate.guard';
import {OrganizationsViewComponent} from '@synthroneApp/components/views/organizations-view/organizations-view.component';
import {OrganizationAddViewComponent} from '@synthroneApp/components/views/organization-add-view/organization-add-view.component';
import {OrganizationsComponentsViewComponent} from '@synthroneApp/components/views/organizations-components-view/organizations-components-view.component';
import {OrganizationParametersViewComponent} from '@synthroneApp/components/views/organization-parameters-view/organization-parameters-view.component';
import {OrganizationFontsViewComponent} from './components/views/organization-fonts-view/organization-fonts-view.component';
import {LanguagesViewComponent} from '@synthroneApp/components/views/languages-view/languages-view.component';
import {SectionsViewComponent} from '@synthroneApp/components/views/sections-view/sections-view.component';
import {SectionAddViewComponent} from '@synthroneApp/components/views/section-add-view/section-add-view.component';
import {ComponentsViewComponent} from '@synthroneApp/components/views/components-view/components-view.component';
import {ComponentAddViewComponent} from '@synthroneApp/components/views/component-add-view/component-add-view.component';
import {ComponentVariantsViewComponent} from '@synthroneApp/components/views/component-variants-view/component-variants-view.component';
import {PlatformsViewComponent} from '@synthroneApp/components/views/platforms-view/platforms-view.component';
import {PlatformAddViewComponent} from '@synthroneApp/components/views/platform-add-view/platform-add-view.component';
import {PlatformTemplateViewComponent} from '@synthroneApp/components/views/platform-template-view/platform-template-view.component';
import {AttributesViewComponent} from '@synthroneApp/components/views/attributes-view/attributes-view.component';
import {AttributeAddViewComponent} from '@synthroneApp/components/views/attribute-add-view/attribute-add-view.component';
import {CountriesViewComponent} from '@synthroneApp/components/views/countries-view/countries-view.component';
import {AttributesGroupsViewComponent} from '@synthroneApp/components/views/attributes-groups-view/attributes-groups-view.component';
import {AttributesGroupsAddViewComponent} from '@synthroneApp/components/views/attributes-groups-add-view/attributes-groups-add-view.component';
import {PipelinesViewComponent} from '@synthroneApp/components/views/pipelines-view/pipelines-view.component';
import {PipelineAddViewComponent} from '@synthroneApp/components/views/pipeline-add-view/pipeline-add-view.component';
import {OrganizationsFeaturesViewComponent} from './components/views/organizations-features-view/organizations-features-view.component';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
    canActivate: [AuthenticateGuard]
  },
  {
    path: 'dashboard',
    component: DashboardViewComponent,
    canActivate: [AuthenticateGuard]
  },
  {
    path: 'users',
    component: UsersViewComponent,
    canActivate: [AuthenticateGuard]
  },
  {
    path: 'notifications',
    component: NotificationsViewComponent,
    canActivate: [AuthenticateGuard]
  },
  {
    path: 'maintenance',
    component: MaintenanceViewComponent,
    canActivate: [AuthenticateGuard]
  },
  {
    path: 'login',
    component: LoginViewComponent
  },

  {
    path: 'organizations',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        redirectTo: '1/10',
        pathMatch: 'full'
      },
      {
        path: 'parameters/:id',
        component: OrganizationParametersViewComponent
      },
      {
        path: 'add',
        component: OrganizationAddViewComponent
      },
      {
        path: 'edit/:id',
        component: OrganizationAddViewComponent
      },
      {
        path: 'fonts/:planet',
        component: OrganizationFontsViewComponent
      },
      {
        path: 'components/:planet',
        component: OrganizationsComponentsViewComponent
      },
      {
        path: 'components/:planet/:page',
        component: OrganizationsComponentsViewComponent
      },
      {
        path: 'components/:planet/:page/:limit',
        component: OrganizationsComponentsViewComponent
      },
      {
        path: 'components/:planet/:page/:limit/:sort',
        component: OrganizationsComponentsViewComponent
      },
      {
        path: 'features/:planet',
        component: OrganizationsFeaturesViewComponent
      },
      {
        path: 'features/:planet/:page',
        component: OrganizationsFeaturesViewComponent
      },
      {
        path: 'features/:planet/:page/:limit',
        component: OrganizationsFeaturesViewComponent
      },
      {
        path: ':page',
        component: OrganizationsViewComponent
      },
      {
        path: ':page/:limit',
        component: OrganizationsViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: OrganizationsViewComponent
      }
    ]
  },
  {
    path: 'languages',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        redirectTo: '1/10',
        pathMatch: 'full'      },
      {
        path: ':page',
        component: LanguagesViewComponent
      },
      {
        path: ':page/:limit',
        component: LanguagesViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: LanguagesViewComponent
      }
    ]
  },
  {
    path: 'countries',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        redirectTo: '1/10',
        pathMatch: 'full'
      },
      {
        path: ':page',
        component: CountriesViewComponent
      },
      {
        path: ':page/:limit',
        component: CountriesViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: CountriesViewComponent
      }
    ]
  },
  {
    path: 'sections',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: SectionsViewComponent
      },
      {
        path: 'add',
        component: SectionAddViewComponent
      },
      {
        path: 'edit/:id',
        component: SectionAddViewComponent
      },
      {
        path: ':page',
        component: SectionsViewComponent
      },
      {
        path: ':page/:limit',
        component: SectionsViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: SectionsViewComponent
      }
    ]
  },
  {
    path: 'components',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: ComponentsViewComponent
      },
      {
        path: 'add',
        component: ComponentAddViewComponent
      },
      {
        path: 'edit/:id',
        component: ComponentAddViewComponent
      },
      {
        path: 'edit/:id/variants',
        component: ComponentVariantsViewComponent
      },

      {
        path: 'edit/:id/variants/:page',
        component: ComponentVariantsViewComponent
      },
      {
        path: 'edit/:id/variants/:page/:limit',
        component: ComponentVariantsViewComponent
      },
      {
        path: 'edit/:id/variants/:page/:limit/:sort',
        component: ComponentVariantsViewComponent
      },
      {
        path: ':page',
        component: ComponentsViewComponent
      },
      {
        path: ':page/:limit',
        component: ComponentsViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: ComponentsViewComponent
      }
    ]
  },
  {
    path: 'platforms',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: PlatformsViewComponent
      },
      {
        path: 'add',
        component: PlatformAddViewComponent
      },
      {
        path: 'template/:id',
        component: PlatformTemplateViewComponent
      },
      {
        path: 'edit/:id',
        component: PlatformAddViewComponent
      },
      {
        path: ':page',
        component: PlatformsViewComponent
      },
      {
        path: ':page/:limit',
        component: PlatformsViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: PlatformsViewComponent
      }
    ]
  },
  {
    path: 'pipelines',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: PipelinesViewComponent
      },
      {
        path: 'add',
        component: PipelineAddViewComponent
      },
      {
        path: 'edit/:id',
        component: PipelineAddViewComponent
      },
      {
        path: ':page',
        component: PipelinesViewComponent
      },
      {
        path: ':page/:limit',
        component: PipelinesViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: PipelinesViewComponent
      }
    ]
  },
  {
    path: 'attributes',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: AttributesViewComponent
      },
      {
        path: 'add',
        component: AttributeAddViewComponent
      },
      {
        path: 'edit/:id',
        component: AttributeAddViewComponent
      },
      {
        path: ':page',
        component: AttributesViewComponent
      },
      {
        path: ':page/:limit',
        component: AttributesViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: AttributesViewComponent
      }
    ]
  },
  {
    path: 'attributes-groups',
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        component: AttributesGroupsViewComponent
      },
      {
        path: 'add',
        component: AttributesGroupsAddViewComponent
      },
      {
        path: 'edit/:id',
        component: AttributesGroupsAddViewComponent
      },
      {
        path: ':page',
        component: AttributesGroupsViewComponent
      },
      {
        path: ':page/:limit',
        component: AttributesGroupsViewComponent
      },
      {
        path: ':page/:limit/:sort',
        component: AttributesGroupsViewComponent
      }
    ]
  },
  {path: '**', component: PageNotFoundComponent}
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts